(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .factory('ChartService', ChartService);

  function ChartService(){

    return {
      getSizeAdviceChart : getSizeAdviceChart,
      getBarChartWithoutLabel : getBarChartWithoutLabel,
      getBarChartWithLabel: getBarChartWithLabel
    };

    function getSizeAdviceChart(chartData) {
      return _.defaultsDeep({data: chartData}, {
        fn: {
          value: _.property('sizeAdvice'),
          color: ['#ABABAB']
        }
      });
    }

    function getBarChartWithoutLabel(chartData){
      return _.defaultsDeep({data: angular.copy(chartData)}, {
        dontRank : true,
        fn: {
          value : _.property('percent'),
          color : '#7C0A40',
          valueLabel : function (d) {
            return (d.percent * 100).toFixed(1) + '%';
          }
        }
      });
    }

    function getBarChartWithLabel(chartData) {
      return _.defaultsDeep(getBarChartWithoutLabel(chartData), {
        fn: {
          label : function(d) {
            return d.label;
          }
        }
      });
    }

  }
})();